import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import { Button } from '../components/ui/button';

const OrderConfirmationPage = () => {
  const orderNumber = `ER-${Date.now().toString().slice(-8)}`;

  return (
    <div className="min-h-screen flex items-center justify-center py-12">
      <div className="max-w-md mx-auto text-center px-4">
        <CheckCircle className="w-20 h-20 text-green-500 mx-auto mb-6" />
        <h1 className="text-3xl font-serif mb-4">Thank You!</h1>
        <p className="text-gray-600 mb-2">Your order has been placed successfully.</p>
        <p className="text-sm text-gray-500 mb-8">Order Number: <span className="font-mono font-medium">{orderNumber}</span></p>
        
        <div className="bg-gray-50 p-6 mb-8 text-left">
          <h3 className="font-medium mb-3">What's Next?</h3>
          <ul className="text-sm text-gray-600 space-y-2">
            <li>• You'll receive an email confirmation shortly</li>
            <li>• We'll notify you when your order ships</li>
            <li>• Expected delivery: 3-5 business days</li>
          </ul>
        </div>

        <Link to="/">
          <Button className="bg-[#2d4a47] hover:bg-[#1e3633] text-white rounded-none px-8">
            Continue Shopping
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default OrderConfirmationPage;
